import { render } from "./GPTsView.vue?vue&type=template&id=21fd3bfa&scoped=true"
import script from "./GPTsView.vue?vue&type=script&lang=js"
export * from "./GPTsView.vue?vue&type=script&lang=js"

import "./GPTsView.vue?vue&type=style&index=0&id=21fd3bfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fd3bfa"]])

export default __exports__